import AllModulePageInformation from "./Tabs/AllModulePageInformation";
import AllProjects from "./Tabs/AllProjects";
import HelpAndAbout from "./Tabs/HelpAndAbout";
import ModuleDocumentations from "./Tabs/ModuleDocumentations";
import {Logs} from "./Tabs/Logs";
import ModulesUsage from "./Tabs/ModulesUsage";
import ApiKeyManagement from "./Tabs/ApiKeyManagement";
import IdFinder from "./Tabs/IdFinder";
import {IContent} from "../../HubFramework";
import {UserRoles} from "../../Utils";
import {odxIconSets} from "../../OdxComponents/constants";
import AdminUserManagement from "./Tabs/UserManagement";

/**
 * The content of the module
 * This is mandatory for every module. It contains all the information about the module.
 */
export const moduleContent: IContent = {
    title: "DevSecOps Hub",
    defaultPage: "All Projects",
    moduleName: "Hub",
    pages: [
        {
            displayName: "All Projects",
            contentPage: AllProjects,
            minimumRole: UserRoles.neutral,
            icon: {
                name: "folder",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "All Modules",
            contentPage: ModuleDocumentations,
            minimumRole: UserRoles.neutral,
            icon: {
                name: "document",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Help and About",
            contentPage: HelpAndAbout,
            minimumRole: UserRoles.neutral,
            icon: {
                name: "help",
                iconSet: odxIconSets.core
            },
        }, //todo: what to do with this?
        {
            displayName: "",
            contentPage: null,
            separator: true,
            minimumRole: UserRoles.admin,
            icon: {
                name: "separator",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Users & Permissions",
            contentPage: AdminUserManagement,
            minimumRole: UserRoles.admin,
            icon: {
                name: "user",
                iconSet: odxIconSets.core
            },

        },
        {
            displayName: "Api Keys",
            contentPage: ApiKeyManagement,
            minimumRole: UserRoles.admin,
            icon: {
                name: "lock",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Logs",
            contentPage: Logs,
            minimumRole: UserRoles.admin,
            icon: {
                name: "history",
                iconSet: odxIconSets.safety
            },
        },
        {
            displayName: "Id Finder",
            contentPage: IdFinder,
            minimumRole: UserRoles.admin,
            icon: {
                name: "search",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Modules Usage",
            contentPage: ModulesUsage,
            minimumRole: UserRoles.admin,
            icon: {
                name: "bar-chart",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Modules Page Info",
            contentPage: AllModulePageInformation,
            minimumRole: UserRoles.admin,
            icon: {
                name: "info",
                iconSet: odxIconSets.core
            },
        }
    ],
};
